import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import LoggedInLayout from '../LoggedInLayout/LoggedInLayout';
import MyAccountSection from '../../components/sections/MyAccount/MyAccount';
import LoggedInFooter from '../LoggedInFooter/LoggedInFooter';
import { fetchUserProfile, selectAccount } from '../../store/slices/accountSlice';
import { getSubscription } from '../../store/slices/subscriptionsSlice';
import { useMediaQuery } from '@mui/material';
import { theme } from '../../theme/theme';
import Footer from '../../components/footer/Footer';

const MyAccount = () => {
  const dispatch = useDispatch();
  const { isSuccess, data } = useSelector(selectAccount);

  const [opened, setOpened] = useState(false);

  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  useEffect(() => {
    if (!data) {
      dispatch(fetchUserProfile());
    }
  }, [dispatch, data]);

  useEffect(() => {
    if (isMobile && opened) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isMobile, opened]);

  return (
    <LoggedInLayout>
      <MyAccountSection data={data} setOpened={setOpened} opened={opened} />
      <Footer />
    </LoggedInLayout>
  );
};

export default MyAccount;
